import React from 'react';

export const AdultsOnlyFellatioIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M33.76 34.5799C36.4331 34.5799 38.6 32.413 38.6 29.7399C38.6 27.0668 36.4331 24.8999 33.76 24.8999C31.087 24.8999 28.92 27.0668 28.92 29.7399C28.92 32.413 31.087 34.5799 33.76 34.5799Z"
        fill="#FF6AA0"
      />
      <path
        d="M28.1 33.38C25.82 37.22 24.78 39.54 24.22 42.7C24.3 43.98 25.6 44.52 27.18 45.52C27.44 45.68 28 46.02 28.24 46.2C30.82 47.86 30.5 51.42 28.12 52.62C27.48 52.94 27.22 52.98 26.94 53.06C22.92 53.66 19.3 53.26 15.36 52.58C11.56 50.96 24.16 47.48 24.94 46.76C24.98 46.72 25.08 46.64 24.76 46.78C24.66 46.88 24.22 46.9 23.56 48.08C23.38 48.46 23.3 48.8 23.26 49.26C23.18 50.4 23.68 51.36 24.48 52.02C20.68 51.24 15.9 47.36 16.24 42.58C16.24 36.64 22.1 31.14 27.88 32.62C28.22 32.7 28.34 33.12 28.12 33.38H28.1Z"
        fill="#FF6AA0"
      />
      <path
        d="M33.76 19.96C36.4331 19.96 38.6 17.7931 38.6 15.12C38.6 12.447 36.4331 10.28 33.76 10.28C31.087 10.28 28.92 12.447 28.92 15.12C28.92 17.7931 31.087 19.96 33.76 19.96Z"
        fill="#00A6ED"
      />
      <path
        d="M40.12 19.7599C47.02 23.9799 53.38 38.2599 42.36 41.5399C39.46 42.2199 38.44 41.8999 36.92 42.4999C35.62 43.5399 35.48 45.5799 35.1 47.5199L34.54 52.5199C34.5 52.9799 34.08 53.3199 33.62 53.2799C33.34 53.2399 33.1 53.0799 32.98 52.8599C32.12 51.2999 31.38 49.6399 30.92 47.8799C28.6 39.3599 32.44 35.5599 40.18 34.0599C40.6 33.9199 40.72 33.7399 40.52 33.8799C40.24 34.2199 40.32 34.2599 40.38 33.8799C40.48 33.1599 40.42 31.6799 40.24 30.2399C39.9 27.2399 39.36 23.8999 39.44 20.1199C39.44 19.7799 39.86 19.5599 40.14 19.7599H40.12Z"
        fill="#00A6ED"
      />
    </svg>
  );
};
